// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Ajay Kulkarni",
  logo_name: "AjayKulkarni",
  nickname: "she_calls_me_putta",
  subTitle:
    "A passionate individual who is hearing impaired since birth. I was the mentor for 3rd edition of Learn IT, Girl which is an international program which was started by Google and Anita Borg. I have 5+ years of experience in software, product development, enterprise mobile application development and delivering Engineering solutions.  I’m a technology enthusiast who is looking forward for chances to develop technologies that is affordable by common people. I won People’s Choice award in Jugaadathon which was organized by Dell and got 2nd place in AI COE Hackathon organized by Dell.",
  resumeLink:
    "https://drive.google.com/file/d/19DVzyCHkGFamkO09Xx7oVdNr5G4Hspbp/"
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/akulkarni9",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ajaykulkarni1/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:ajaykulkarni178@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/anku_linuxgeek",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/kulkarni3/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/she_calls_me_putta/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deep learning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Experience of working with Google Actions",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Mobile Application Development & Front End Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building e2e native android applications by using Kotlin/Java ",
        "⚡ Developing cross platform and hybrid mobile applications using Flutter, React Native, Phonegap, Cordova, Ionic",
        "⚡ Developing resposive, visually pleasing front end by using Bootstrap, Material, React and AngularJS"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "AngularJS",
          fontAwesomeClassname: "simple-icons:angularjs",
          style: {
            color: "#E23237",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Android Studio",
          fontAwesomeClassname: "simple-icons:androidstudio",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: {
            color: "#0095D5",
          },
        },
        {
          skillName: "PhoneGap",
          fontAwesomeClassname: "simple-icons:adobephonegap",
          style: {
            color: "#27A1C5",
          },
        },
        {
          skillName: "Cordova",
          fontAwesomeClassname: "simple-icons:apachecordova",
          style: {
            color: "#E8E8E8",
          },
        },
        {
          skillName: "Ionic",
          fontAwesomeClassname: "simple-icons:ionic",
          style: {
            color: "#3880FF",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563D7C",
          },
        },
        {
          skillName: "Material",
          fontAwesomeClassname: "simple-icons:material-ui",
          style: {
            color: "#0081CB",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/Ajay_Kulkarni",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/akulkarni9",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "http://www.hackerearth.com/@Ajay_Kulkarni",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/akulkarni9",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Birla Institute of Technology and Science, Pilani",
      subtitle: "M.Tech in Software Systems",
      logo_path: "BITS_Pilani-Logo.png",
      alt_name: "BITS Pilai",
      duration: "2019 - Present",
      descriptions: [
        "⚡ I have studied subjects like DS, Algorithms, Advanced DBMS, Software Architecture, AI etc.",
        "⚡ Apart from this, I have done courses on Data mining, Information Retrieval, Usability Engineering and Machine Learning.",
      ],
      website_link: "https://www.bits-pilani.ac.in/",
    },
    {
      title: "JSSSTU, Mysore (Formerly SJCE, Mysore) ",
      subtitle: "B.E in Computer Science",
      logo_path: "jssstu.png",
      alt_name: "BITS Pilai",
      duration: "2009 - 2013",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DBMS, OS etc.",
        "⚡ Apart from this, I have done courses on Software Engineering, Compiler Design, web development and much more.",
      ],
      website_link: "https://jssstuniv.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Certified Scrum Master",
      subtitle: "Scrum Alliance",
      logo_path: "SA.png",
      certificate_link:
        "https://drive.google.com/file/d/1BAHMbzX4VErJMJ6cG_WVN_k062V7Cqwo/view?usp=sharing",
      alt_name: "Scrum Alliance",
      color_code: "#8C151599",
    },
    {
      title: "Certified Scrum Developer",
      subtitle: "Scrum Alliance",
      logo_path: "SA.png",
      certificate_link:
        "https://drive.google.com/file/d/1mYFUMEMi6YWsO5sat9BKgXnL7e_hl-UC/view?usp=sharing",
      alt_name: "Scrum Alliance",
      color_code: "#4285F499",
    },
    {
      title: "Mentor",
      subtitle: "Learn IT, Girl",
      logo_path: "learnIt.jpg",
      certificate_link:
        "https://www.credential.net/ac55d7d5-5e9e-4345-8dfb-c950b6f54818",
      alt_name: "Learn IT, Girl",
      color_code: "rgba(0, 0, 0, 0.6)",
    },
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I have worked with some evolving startups as Software Developer and AVP, Product and Technology. I have also worked with some well established companies mostly as Software Engineer.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "EMC Corporation (Dell Technologies)",
          company_url: "https://www.dell.com/en-in",
          logo_path: "DellTech.png",
          duration: "October, 2017 - PRESENT",
          location: "Bengaluru, Karnataka",
          description:
            "Successful delivery of all projects by developing excellent functionalities from requirements, documentation, change management, UAT and deployment of the solution in production. Developed code and system design for all solutions. Participated in the design, testing and deployment of client/server, multitier applications and related components. Proposed that Test Driven Development - TDD is very important and gave a seminar on TDD. Completed training on Certified Scrum Master (CSM) and Certified Scrum Developer (CSD).",
          color: "#0879bf",
        },
        {
          title: "Software Engineer",
          company: "enEXL Technologies",
          company_url: "https://www.linkedin.com/company/enexl-technologies/",
          logo_path: "enexl.png",
          duration: "June, 2015 - March, 2017",
          location: "Bengaluru, Karnataka",
          description:
            "Took responsibility for Web-based application programming within high-volume setting. Became adept in analyzing code for system testing and debugging. Interacted with clients, managed a project, Vetas. Delivered functional specs, project plans, reviews, UAT and deployment of solutions. Developed and implemented cross-platform mobile apps, coded new solutions that were accessible and scalable.",
          color: "#9b1578",
        },
        {
          title: "AVP, Product And Technology",
          company: "Cheerz Labs",
          company_url: "https://www.linkedin.com/company/cheerz-labs/",
          logo_path: "cheerz.jpg",
          duration: "September, 2014 - March, 2015",
          location: "Bengaluru, Karnataka",
          description:
            "Communicating with internal/external clients to determine specific requirements and expectations, managing client expectations, project plan and project schedule. Managed projects and teams. Delivered many key stone projects. Developed Zen project which involves a headset which has at last 16 electrodes and can read brain waves. Developed custom BCI interface. Developed Tizen mobile apps.",
          color: "#fc1f20",
        },
        {
          title: "Software Engineer",
          company: "DF3D Creations Pvt Ltd",
          company_url: "http://www.df3d.com/",
          logo_path: "df3d.png",
          duration: "May, 2014 - July, 2014",
          location: "Bengaluru, Karnataka",
          description:
            "Developed commerce site for df3d.",
          color: "#8C1515",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Intern",
          company: "VA Techventures Pvt Ltd (Happay).",
          company_url: "https://happay.com/",
          logo_path: "happay.png",
          duration: "Sep 2013 - Oct 2013",
          location: "Mysore, India",
          description:
            "Worked with business development team for improving the market of Happay. Conducted seminars in colleges about Happay, retail marketing etc..",
          color: "#ee3c26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create android applications by using AI, ML, VR and build them using gradle.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ajay.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, VR, React, React Native, AngularJS, Cordova, Ionic Android and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For fundamental empowerment, I like to write lessons that creates impact on each of the reader individually so that they can learn programming.",
    link: "https://akulkarni143.wordpress.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "B311, Platinum Lifestyle Apartments, 16/9, 80 Feet BDA Road, Kothanur, 8th Phase, J. P. Nagar, Bengaluru, Karnataka 560083",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Platinum+Lifestyle/@12.8651783,77.5754097,15z/data=!4m5!3m4!1s0x0:0xd9ac3eed2ad84745!8m2!3d12.8651783!4d77.5754097",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9686243396",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
